import { Pipe, PipeTransform } from '@angular/core';
import { removeNonDigit } from '../utils/utils';
/*
 * Filter emails domain of an address
 * Usage:
 *   filter : value to transform
*/
@Pipe({ name: 'filterEmailDomain' })
export class FilterEmailDomainPipe implements PipeTransform {
  public transform(items: Array<{view:string, viewValue:string}>, filterValue: string): any {
    
    if(!items) {
      return [];
    }

    if(filterValue){

      if(filterValue.split('@').length < 1){
        filterValue = undefined;
      }
      else{
        filterValue = filterValue.split('@')[1];
      }      
    }

    if(!filterValue) {
      return items;
    }
    
    return items.filter(item => { 
      return item.viewValue.indexOf(filterValue) > -1;
    });
  };
}